import { render, staticRenderFns } from "./settingsModal.vue?vue&type=template&id=e90be518&scoped=true"
import script from "./settingsModal.vue?vue&type=script&lang=js"
export * from "./settingsModal.vue?vue&type=script&lang=js"
import style0 from "./settingsModal.vue?vue&type=style&index=0&id=e90be518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90be518",
  null
  
)

export default component.exports